/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Sitesettings_Brand_Badge1Inputs */

const vi_sitesettings_brand_badge1 = /** @type {(inputs: Sitesettings_Brand_Badge1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Huy hiệu ${i?.n}`)
};

/**

* @param {Sitesettings_Brand_Badge1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_badge1 = /** @type {((inputs: Sitesettings_Brand_Badge1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Badge1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_badge1(inputs)
});
export { sitesettings_brand_badge1 as "siteSettings_brand_badge" }